import { gql } from "gql";

export const SAVE_PERSON_LANGUAGE_SETTINGS = gql(`
  mutation SavePersonLanguageSettings($settings: PersonLanguageSettingsInput!) {
    savePersonLanguageSettings(settings: $settings)
  }
`);
